<template>
  <v-container>
    <v-card>
      <v-card-title>
        Grupy Terapeutów
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="openCreateDialog">          
          Dodaj Nową Grupę
        </v-btn>
      </v-card-title>

      <v-data-table :headers="headers" :items="groups" hide-default-footer disable-pagination class="elevation-1" :loading="loading"
        loading-text="Ładowanie... Proszę czekać">
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)" title="Edytuj grupe">fa-user-edit</v-icon>                          
          <v-icon small class="mr-2" @click="deleteItem(item)" title="Usuń grupe">fa-trash-alt</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <!-- Create/Edit Dialog -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="editedItem.name" label="Nazwa Grupy"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Anuluj</v-btn>
          <v-btn color="blue darken-1" text @click="save">Zapisz</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">
          Czy na pewno chcesz usunąć tę grupę?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeleteDialog">Anuluj</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { therapistsService } from '@/services';


export default {
  data() {
    return {
      groups: [],
      headers: [
        { text: 'Nazwa', value: 'name' },
        { text: 'Akcje', value: 'actions', sortable: false },
      ],
      dialog: false,
      deleteDialog: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
      },
      defaultItem: {
        id: null,
        name: '',
      },
      loading: false,
    };
  },
  mounted() {
    this.fetchGroups();
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nowa Grupa' : 'Edytuj Grupę';
    },
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
    deleteDialog(val) {
      val || this.closeDeleteDialog();
    },
  },
  methods: {
    async fetchGroups() {
      this.loading = true;
      try {
        var result = await therapistsService.getTherapistGroups();
        
        this.groups = result.data.result;
      } catch (error) {
        console.error('Błąd podczas pobierania grup');
      } finally {
        this.loading = false;
      }
    },
    openCreateDialog() {
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = this.groups.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.groups.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.deleteDialog = true;
    },
    async deleteItemConfirm() {
      try {
        await therapistsService.deleteTherapistGroup(this.editedItem.id);
        await this.fetchGroups();
        this.closeDeleteDialog();
      } catch (e) {
        if (
              e.response != null &&
              e.response.data != null &&
              e.response.data.error != null
            ) {
              this.showError(false, e.response.data.error.message);
            } else {
              this.showError(false, "Nie można usunąć grupy");
            }
      }
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(value => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      try {
        if (this.editedIndex > -1) {
          // Update existing group
          await therapistsService.updateTherapistGroup(this.editedItem);
          await this.fetchGroups();
        } else {
          // Add new group
           await therapistsService.addTherapistGroup({id: 0, name: this.editedItem.name});
           await this.fetchGroups();
          //this.groups.push(response.data);
        }
        this.closeDialog();
      } catch (e) {
        console.log(e)
        if (
              e.response != null &&
              e.response.data != null &&
              e.response.data.error != null
            ) {
              this.showError(false, e.response.data.error.message);
            } else {
              this.showError(false, "Nie można zapisać grupy");
            }
      }
    },
  },
};
</script>

<style scoped>
.action-icon {
  cursor: pointer;
  color: #757575;
}

.action-icon:hover {
  color: #000;
}
</style>